import React from "react";

const UserSettings = () => {
  return (
    <div>
      <h1 className="route">User Settings</h1>
    </div>
  );
};

export default UserSettings;
